import { inject, Injector } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { from, map, switchMap } from 'rxjs';
import { PlatformService } from '../services/platform.service';

export const authGuard: CanActivateFn = () => {
  const injector = inject(Injector);
  const router = inject(Router);
  const platformService = inject(PlatformService);

  if (!platformService.browser()) return true;

  return from(import('@auth0/auth0-angular'))
    .pipe(
      map((module) => module.AuthService),
      switchMap((auth) => injector.get(auth).user$),
      map((user) => {
        if (user) return true;
        router.navigate(['/']);
        return false;
      })
    );
};